export const en = {
    'accepted-status': 'Accepted for display',
    'active-status': 'Active',
    'archived-status': 'Archived',
    'banner-type-content-promotion': 'Content promotion',
    'banner-type-cpm-indoor': 'Indoor advertising',
    'banner-type-cpm-indoor-1': 'Indoor advertising',
    'banner-type-cpm-outdoor': 'Outdoor advertising',
    'banner-type-cpm_audio': 'Audio',
    'banner-type-cpm_banner': 'Display banner',
    'banner-type-cpm_geoproduct': 'Banner in Yandex.Metro',
    'banner-type-cpm_geoproduct-new': 'Banner on geo sites',
    'banner-type-cpm_price': 'todo',
    'banner-type-cpm_video': 'Video',
    'banner-type-cpm_yndx_frontpage': 'Display banner on the Yandex Home page',
    'banner-type-dynamic': 'Dynamic ad',
    'banner-type-internal': 'Indoor advertising',
    'banner-type-internal-autobudget': 'Auto-budget campaign',
    'banner-type-internal-distrib': 'Distribution ads',
    'banner-type-internal-free': 'Free ads',
    'banner-type-mcbanner': 'Search banner',
    'banner-type-performance': 'Smart banner',
    'banner-type-text-mobile': 'Mobile Text & Image Ad',
    'button-group-type-chooser-banners': 'Banners',
    'custom-targeting': 'todo',
    'date-campaigns': 'todo',
    displays: 'todo',
    'draft-status': 'Draft',
    'edit-group-hint-campaigns-part': {
        one: 'out of {countCampaigns} campaign',
        some: 'out of {countCampaigns} campaigns',
        many: 'out of {countCampaigns} campaigns',
        none: 'out of {countCampaigns} campaigns'
    },
    'edit-group-hint-groups-part': {
        one: '{count} ad group selected',
        some: '{count} ad groups selected',
        many: '{count} ad groups selected',
        none: '{count} ad groups selected'
    },
    'edit-group-hint-only-campaigns-part': {
        one: '{count} campaign selected',
        some: '{count} campaigns selected',
        many: '{count} campaigns selected',
        none: '{count} campaigns selected'
    },
    'fixed-targeting': 'todo',
    'group-type-chooser-audio': 'audio',
    'group-type-chooser-banners': 'banners',
    'group-type-chooser-geoproduct': 'banner in Yandex.Metro',
    'group-type-chooser-geoservice': 'banner on geo sites',
    'group-type-chooser-indoor': 'internal advertising',
    'group-type-chooser-indoor-1': 'indoor advertising',
    'group-type-chooser-outdoor': 'outdoor advertising',
    'group-type-chooser-video': 'video',
    'group-type-text': 'Text & Image ad',
    ltv: 'todo',
    'moderation-status': 'Under moderation',
    'no-status': 'Ads not created',
    'preaccepted-status': 'Preliminarily accepted for display',
    'previous-version-showing-status-desc': 'Show previous version',
    'processing-status': 'Processing',
    'rejected-status': 'Rejected',
    'showing-status': 'Ads are being served',
    'showing-status-desc': 'Ads are being served',
    'stopped-status': 'Stopped',
    'title-package': 'todo'
};
